import React from 'react';

import {
  Actions as ActionsUI,
  Action,
  ContentCopyIcon,
  FileDownloadIcon,
  InsertPhotoIcon,
  EditIcon,
  UnarchiveIcon,
  ArchiveIcon,
  DeleteIcon,
  CommentIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

const Actions = ({
  actions,
  limit = 3,
  onArchive,
  onEdit,
  onDelete,
  onUnarchive,
  onMoveToPreview,
  onActivate,
  onCopyLink,
  onCopyNameKey,
  onDownload,
  onOpenOriginal,
  onSwapWithOriginal,
  onExportToExcel,
  onShare,
  onMoveTo,
  onOpenComments,
  color,
  withAddComment,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <ActionsUI limit={limit} color={color}>
          <Action label={'Copy'} icon={<ContentCopyIcon />}>
            <Action
              label={'Copy URL'}
              disabled={!isActionAllowed('Copy URL')}
              onClick={onCopyLink}
            />
            <Action label={'Copy name & IMG key'} onClick={onCopyNameKey} />
          </Action>
          <Action icon={<FileDownloadIcon />} label={'Download'}>
            <Action
              id={'cloud_download'}
              label={'Export to excel'}
              disabled={!isActionAllowed('Export to excel')}
              onClick={onExportToExcel}
            />
            <Action
              id={'download'}
              label={'Download'}
              disabled={!isActionAllowed('Download')}
              onClick={onDownload}
            />
          </Action>
          {isActionAllowed('View Original') && (
            <Action
              icon={<InsertPhotoIcon />}
              label={'View Original'}
              onClick={onOpenOriginal}
            />
          )}
          {isActionAllowed('Swap with Original') && (
            <Action label={'Swap with Original'} onClick={onSwapWithOriginal} />
          )}
          {withAddComment ? (
            <Action
              id={'add_comment'}
              label={'Add comment'}
              icon={<CommentIcon />}
              disabled={!isActionAllowed('Add comment')}
              onClick={onOpenComments}
            />
          ) : null}
          {isActionAllowed('Share') && (
            <Action label={'Share'} onClick={onShare} />
          )}
          {isActionAllowed('Move to ...') && (
            <Action label={'Move to ...'} onClick={onMoveTo} />
          )}

          {isActionAllowed('Edit') && (
            <Action
              id={'edit'}
              icon={<EditIcon />}
              label={'Edit'}
              onClick={onEdit}
            />
          )}
          {isActionAllowed('Archive') && (
            <Action
              icon={<ArchiveIcon />}
              label={'Archive'}
              onClick={onArchive}
            />
          )}
          {isActionAllowed('Unarchive') && (
            <Action
              icon={<UnarchiveIcon />}
              label={'Unarchive'}
              onClick={onUnarchive}
            />
          )}
          {isActionAllowed('Activate') && (
            <Action label={'Activate'} onClick={onActivate} />
          )}
          {isActionAllowed('Set Preview') && (
            <Action label={'Move to preview'} onClick={onMoveToPreview} />
          )}
          {isActionAllowed('Delete') && (
            <Action
              id={'delete'}
              icon={<DeleteIcon />}
              label={'Delete'}
              onClick={onDelete}
            />
          )}
        </ActionsUI>
      )}
    </Permissions>
  );
};

export default Actions;
